exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-reload-dialog {\n  display: block;\n}", ""]);

// exports
